import { render } from "./carrierCard.vue?vue&type=template&id=f2b6d1b8&scoped=true"
import script from "./carrierCard.vue?vue&type=script&lang=js"
export * from "./carrierCard.vue?vue&type=script&lang=js"

import "./carrierCard.vue?vue&type=style&index=0&id=f2b6d1b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b6d1b8"]])

export default __exports__